<template>
  <div class="messages-users-list">
    <loading
      :active="loading"
      :can-cancel="false"
      loader="dots"
      color="#2292ef"
      :is-full-page="true"
    ></loading>
    <div class="messages-users-list-search">
      <!-- Search form -->
      <div style="padding-top: 2px;padding-left: 13px;">
        <form class="form-inline .active-cyan-2">
          <input
            class="form-control form-control-sm mr-3 w-75"
            type="text"
            placeholder="Search"
            aria-label="Search"
            style="border-radius: 5px"
            v-model="searchText"
          />
          <i class="fa fa-search" aria-hidden="true"></i>
        </form>
      </div>
    </div>
    <div class="messages-users-list-message">
      <li
        v-for="(offer,index) in searchedOffers"
        :key="index"
        @click="selectOffer(offer)"
        class="messages-users-item"
        :class="{'chat-actived' : offer.id===value}"
      >
        <div class="usermessage-item">
          <div class="messages-users-item-pic">
            <img :src="offer.chat_user_mid_avatar" />
          </div>
          <div class="message-textitem">
            <div class="messages-users-item-username">
              <span>{{offer.chat_user_full_name}}</span>
            </div>

            <div class="messages-users-item-subject">
              <small>{{offer.task.category.title}}</small>
            </div>
            <!-- <div v-if="proposal.unread_messages_count>0" class="messages-users-item-shortmessage">
              <small>
                <span>You have</span>
                <span class="badge badge-info text-white">{{proposal.unread_messages_count}}</span>
                <span>new message</span>
              </small>
            </div>-->
          </div>
        </div>
        <div class="usermessage-time">
          <span>
            <local-time :time="offer.created_at"></local-time>
          </span>
        </div>
      </li>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import LocalTime from "./../../LocalTime";

export default {
  components: {
    Loading,
    LocalTime
  },
  props: {
    value: {
      type: [String, Number]
    }
  },
  data() {
    return {
      loading: false,
      offers: [],
      searchedOffers: [],
      searchText: null
    };
  },
  created() {
    let self = this;
    axios({
      url:
        "/api/v1/offer/get-all-user-related-offers/" +
        window.user_id +
        "?api_token=" +
        window.api_token
    })
      .then(res => {
        if (res.data.ok) {
          self.offers = res.data.data;
          self.searchedOffers = res.data.data;
        }
      })
      .catch(err => {
        console.log(err);
      });
  },
  methods: {
    selectOffer(offer) {
      this.$emit("input", offer.id);
    }
  },
  watch: {
    searchText: {
      handler() {
        let self = this;
        this.searchedOffers = this.offers.filter(function(item) {
          return item.task.title.includes(self.searchText);
        });
      }
    }
  }
};
</script>
